import React, { Component } from "react";
import FilterableVideoList from "../../components/FilterableVideoList/FilterableVideoList";
import AwardsVideoList from "../../components/AwardsVideoList/AwardsVideoList";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

class CompetitionStageWinners extends Component {
	render() {
			
		if(!this.props.terms) return null;

		const { videos, awards, url } = this.props.competitions[
			this.props.competitionId
		];
		return (
			
			<div>
			<RichText content={this.props.terms.state_winners} />
			<AwardsVideoList
			videos={videos}
			awards={awards}
			competitionSlug={url}
			/>
			<FilterableVideoList
			title="Finalists"
			videos={videos}
			competitionSlug={url}
			/>
			</div>
		);
	}
}

export default withPrismic(withFirebase(CompetitionStageWinners));



// WEBPACK FOOTER //
// ./src/pages/Competition/CompetitionStageWinners.js